import { isNaN } from 'lodash';
import * as yup from 'yup';

import {
  EMAIL_REGEX,
  ONLY_TEXT,
  PASSWORD_REGEX,
  TEXT_WITH_SPACES,
} from './regex';

// @TODO: Replace the `This field is Required` occurences with the below const.
const requiredFieldErrorMessage = 'This field is Required';
const inalidValueErrorMessage = 'Invalid value';

export const signInSchema = yup
  .object()
  .shape({
    signInEmail: yup
      .string()
      .matches(EMAIL_REGEX, 'Invalid Email address')
      .required('This field is Required'),
    signInPassword: yup
      .string()
      .min(8, 'Password is too short - should be 8 chars minimum.')
      .required('This field is Required'),
  })
  .required();

export const signUpSchema = yup
  .object()
  .shape({
    signUpEmail: yup
      .string()
      .matches(EMAIL_REGEX, 'Invalid Email address')
      .required('This field is Required'),
    signUpFirstName: yup
      .string()
      .matches(ONLY_TEXT, 'Invalid First Name')
      .required('This field is Required'),
    signUpLastName: yup
      .string()
      .matches(ONLY_TEXT, 'Invalid Last Name')
      .required('This field is Required'),
    signUpPhone: yup
      .string()
      .min(10, 'Invalid Phone number')
      .required('This field is Required'),
    signUpPassword: yup
      .string()
      .matches(
        PASSWORD_REGEX,
        "Password must contain at least one special characters e.g. '-','+', one digit, and one letter, and should be 8 characters minimum."
      )
      .required('This field is Required'),
    signUpUsagePurpose: yup.string().required('This field is Required'),
  })
  .required();

export const signUpWithGoogleSchema = yup
  .object()
  .shape({
    signUpGoogleUsagePurpose: yup.string().required('This field is Required'),
    signUpGooglePhone: yup.string().required('This field is Required'),
  })
  .required();

export const listPriceSchema = yup
  .object()
  .shape({
    listPrice: yup.string().required('This field is Required'),
    agentCommission: yup.string().required('This field is Required'),
  })
  .required();

export const forgotSchema = yup
  .object()
  .shape({
    forgotEmail: yup
      .string()
      .matches(EMAIL_REGEX, 'Invalid Email address')
      .required('This field is Required'),
  })
  .required();

export const createPasswordSchema = yup
  .object()
  .shape({
    createPassword: yup
      .string()
      .matches(
        PASSWORD_REGEX,
        "Password must contain at least one special characters e.g. '-','+', one digit, and one letter, and should be 8 characters minimum."
      )
      .required('This field is Required'),
    createPasswordConfirm: yup
      .string()
      .oneOf([yup.ref('createPassword'), null], 'Passwords must match'),
  })
  .required();

const leadSchemaShape = {
  address: yup.string().required(requiredFieldErrorMessage),
  email: yup
    .string()
    .matches(EMAIL_REGEX, 'Invalid Email')
    .required(requiredFieldErrorMessage),
  phone_number: yup
    .string()
    .min(10, 'Invalid Phone number')
    .required(requiredFieldErrorMessage),
};

export const listingSchema = yup
  .object()
  .shape({
    ...leadSchemaShape,
    name: yup
      .string()
      .matches(TEXT_WITH_SPACES, 'Invalid Name')
      .required(requiredFieldErrorMessage),
    is_open_to_buy: yup
      .string()
      .nullable()
      .matches(ONLY_TEXT, 'Invalid Value')
      .required(requiredFieldErrorMessage),
  })
  .required();

export const homeValuationSchema = yup
  .object()
  .shape({
    ...leadSchemaShape,
    first_name: yup
      .string()
      .matches(ONLY_TEXT, 'Invalid First Name')
      .required(requiredFieldErrorMessage),
    last_name: yup
      .string()
      .matches(ONLY_TEXT, 'Invalid Last Name')
      .required(requiredFieldErrorMessage),
  })
  .required();

export const listingPropertyTypeSchema = yup
  .object()
  .shape({
    property_type: yup.string().required(requiredFieldErrorMessage),
    is_waterfront_property: yup
      .string()
      .nullable()
      .matches(ONLY_TEXT, 'Invalid Value')
      .required(requiredFieldErrorMessage),
    has_swimming_pool: yup
      .string()
      .nullable()
      .matches(ONLY_TEXT, 'Invalid Value')
      .required(requiredFieldErrorMessage),
  })
  .required();

export const listingPropertyDetailsSchema = yup
  .object()
  .shape({
    bed_count: yup
      .number()
      .required(requiredFieldErrorMessage)
      .min(0, inalidValueErrorMessage)
      .transform((_, val) => (val ? Number(val) : null))
      .nullable(),
    bath_count: yup
      .number()
      .required(requiredFieldErrorMessage)
      .min(0, inalidValueErrorMessage)
      .nullable()
      .transform((_, val) => (val ? Number(val) : null)),
    home_area: yup
      .number()
      .required(requiredFieldErrorMessage)
      .min(0, inalidValueErrorMessage)
      .nullable()
      .transform((_, val) => (val ? Number(val) : null)),
  })
  .required();

// @TODO: Check edge cases for validations
export const listingPriceSchema = yup
  .object()
  .shape({
    desired_price: yup
      .number()
      .required(requiredFieldErrorMessage)
      .min(1, inalidValueErrorMessage)
      .nullable()
      .transform((_, val) => (val ? Number(val) : null)),
    buyer_agent_commission: yup
      .number()
      .min(0, 'Please enter a number from 0 to 3.')
      .max(3, 'Please enter a number from 0 to 3.')
      .nullable()
      .transform((_, val) => (isNaN(val) ? null : Number(val))),
    home_valuation_price: yup
      .number()
      .min(0, inalidValueErrorMessage)
      .nullable(),
  })
  .required();
